import { render, staticRenderFns } from "./PortalTargets.vue?vue&type=template&id=5591e536&"
import script from "./PortalTargets.vue?vue&type=script&lang=js&"
export * from "./PortalTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports